import { themed } from '@heathmont/moon-utils';
import styled from 'styled-components';
import stackMixin from '../stackMixin/stackMixin';
const Stack = styled.div(({ theme, space = 'default' }) => stackMixin(themed('space', space)(theme)));
export default Stack;
